import React from "react";

import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

// const useStyles = makeStyles(theme => ({}));

const OptionalFieldMenuItem = props => {
  const { optionalField, handleClick } = props;
  //   const classes = useStyles();

  return (
    <ListItem button onClick={() => handleClick(optionalField)}>
      <ListItemText>{optionalField.label}</ListItemText>
    </ListItem>
  );
};

export default OptionalFieldMenuItem;
